<template>
  <div>
  <h3>Projects</h3>
  <div class="utils" v-if="loggedIn">
    <v-btn v-if="loggedIn" @click='newProject'>New Project</v-btn>
  </div>
  <DataTable profile="projects" v-on:row-click="openProject">
    <template v-slot:item.content="{ item }">
      <span>{{item.content | summary}}</span>
    </template>
  </DataTable>

  </div>
</template>

<script>
import router from '../plugins/router'
//var log = console.log;

export default {
    data : function() {
        return {
            projects : [],
        }
    },
    computed: {
        loggedIn() {
            return !!this.$store.getters.uuid 
        }
    },
    created : function() {
    },
    methods : {
        openProject : function(p) {
            router.push({ name: 'Project', params: { uuid: p.uuid } })
            return false;
        },
        newProject : function() {
            router.push({ name: 'Project', params: { uuid: 0 } })
        },
    }
}
</script>

<style>
.project-list {
    width: 100%;
}
td {
    margin-left:0px;
}
.item-list {
    margin-left: auto;
    margin-right:auto;
}
.item-list td.title {
    text-align: left;
}
.item-list td.amount {
    text-align: right;
}
</style>
